<template>
    <nav class="navbar navbar-expand-sm bg-white">
        <div class="container">

            <div class="logos">
                <router-link :to="{name: 'home'}">
                    <img class="mr-2 mr-sm-4" src="/img/Titan_Color.png" />
                </router-link>
                <router-link :to="{name: 'home'}">
                    <img class="mr-2 mr-sm-4" src="/img/Goodyear_Color-01.png" />
                </router-link>
            </div>

            <b-button class="navbar-toggler" v-b-toggle.app-navbar-content>
                <span class="navbar-toggler-icon"></span>
            </b-button>

            <b-collapse id="app-navbar-content" :is-nav="true" v-model="visible">
                <ul class="navbar-nav mr-auto">

                    <router-link
                        tag="li"
                        :to="{name: 'home'}"
                        class="nav-item"
                    >
                        <a class="nav-link"><i class="fa fa-home"></i><span>Home</span></a>
                    </router-link>

                    <router-link
                        v-if="online"
                        tag="li"
                        :to="{name: 'contact-us'}"
                        class="nav-item"
                    >
                        <a class="nav-link"><i class="fa fa-envelope" aria-hidden="true"></i><span>Contact Us</span></a>
                    </router-link>
                </ul>
            </b-collapse>

        </div>
    </nav>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({
        visible: false,
    }),
    computed: {
        ...mapState(['online']),
    },
    methods: {
        collapse () {
            this.visible = false
        },
    },
    created () {
        this.$router.afterEach(this.collapse)
    }
}
</script>
